import React, { Component } from 'react'
import { connect } from 'react-redux'

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

export class Home extends Component {
  render () {
    if (this.props.user) {
      return (
        <>
          <div className='grid-home-content-full home-page-content'>
            <h1 className='page-heading'>Browse latest content</h1>
          </div>
          <div className='grid-home-content-left home-page-content'>
            <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='View the latest content for all Areas of Interest'></span>
              </div>
              <figure className='item'>
                <img className='svg-image' src='images/DocumentList.svg' alt='Areas of Interest' />
                <figcaption className='caption'>All Areas of Interest</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewAllAoi' href='/#/search?q=*&aois=&industries=&geos=&topics=&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest' name='btnViewAllAoi' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div>
            <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='Development of data protection and security legislation and the enforcement of these laws globally. Coverage also follows litigation that arises in courts against companies that breach data protection laws'></span>
              </div>
              <figure className='item'>
                <img src='images/Data-Privacy-Icon.png' alt='Data Privacy and Security' />
                <figcaption className='caption'>Data Privacy and Security</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewDPS' href='/#/search?q=*&aois=2001&industries=&geos=&topics=&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest' name='btnViewDPS' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div>
            <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='Trade negotiations, trade disputes and enforcement.  Particularly US Federal-level trade enforcement and litigation and EU enforcement of trade defense rules and follow-on litigation'></span>
              </div>
              <figure className='item'>
                <img src='images/Trade-Icon.png' alt='Trade' />
                <figcaption className='caption'>Trade</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewTrade' href='/#/search?q=*&aois=2006&industries=&geos=&topics=&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest' name='btnViewTrade' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div>
            <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='Global content relating to the regulation of technology, platforms and telecommunications'></span>
              </div>
              <figure className='item'>
                <img src='images/Sector-Regulation.png' alt='Technology' />
                <figcaption className='caption'>Technology</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewTTSR' href='/#/search?q=*&aois=2009&industries=&geos=&topics=&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest' name='btnViewTTSR' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div> 
          </div>
          <div className='grid-home-content-center home-page-content'>
            <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='Enforcement of antitrust rules, such as cartel and abuse of dominance investigations, appeals against decisions and developments in case law that impact the way authorities enforce rules'></span>
              </div>
              <figure className='item'>
                <img src='images/Antitrust-Icon.png' alt='Antitrust' />
                <figcaption className='caption'>Antitrust</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewAntitrust' href='/#/search?q=*&aois=2000&industries=&geos=&topics=&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest' name='btnViewAntitrust' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div>
            <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='Coverage of major regulatory trends shaping the future of mobility. Including connected cars, autonomous driving, electric vehicles/fuel revolution and digital transformation (such as privacy, data sharing and AI)'></span>
              </div>
              <figure className='item'>
                <img src='images/Tag.svg' className='svg-image' alt='Future Mobility' />
                <figcaption className='caption'>Future Mobility</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewFM' href='/#/search?q=*&aois=&industries=&geos=&topics=465&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest&pgn=1' name='btnViewFM' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div>
            <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='Coverage relating to law making and changes to existing regulation, in the European and US financial services sectors'></span>
              </div>
              <figure className='item'>
                <img src='images/Sector-Regulation.png' alt='Financial Services' />
                <figcaption className='caption'>Financial Services</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewFS' href='/#/search?q=*&aois=2008&industries=&geos=&topics=&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest' name='btnViewFS' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div>
            <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='Coverage relating to law making and changes to existing regulation, in the European energy sector'></span>
              </div>
              <figure className='item'>
                <img src='images/Sector-Regulation.png' alt='Energy' />
                <figcaption className='caption'>Energy</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewESR' href='/#/search?q=*&aois=2007&industries=&geos=&topics=&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest' name='btnViewESR' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div>           
          </div>
          <div className='grid-home-content-right home-page-content'>
           <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='Coverage on mergers that require regulatory clearance. Including steps in reviews to get a deal approved, developments in case law about M&A reviews and changes in M&A policy'></span>
              </div>
              <figure className='item'>
                <img src='images/Mergers-Icon.png' alt='Mergers and Acquisitions' />
                <figcaption className='caption'>Mergers and Acquisitions</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewMA' href='/#/search?q=*&aois=2003&industries=&geos=&topics=&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest' name='btnViewMA' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div>
            <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='Enforcement of anti-bribery laws, including investigations and litigation in courts for all industry sectors.  Specific coverage for banking/financial services sectors on other types of financial crime, such as money-laundering, fraud and market manipulation'></span>
              </div>
              <figure className='item'>
                <img src='images/Financial-Crime_Icon.png' alt='Financial Crime' />
                <figcaption className='caption'>Financial Crime</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewFC' href='/#/search?q=*&aois=2002&industries=&geos=&topics=&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest' name='btnViewFC' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div>
            <div className='section-div'>
              <div className='info'>
                <span className='info-icon tooltip bottom' aria-label='The European Union and its member states and investigations initiated by the European Commission to establish whether assistance offered (e.g. tax rebates, grants, etc.) to specific companies breaches EU rules'></span>
              </div>
              <figure className='item'>
                <img src='images/State-Aid-Icon.png' alt='State Aid' />
                <figcaption className='caption'>State Aid</figcaption>
              </figure>
              <div className='cta-action-container'>
                <a id='btnViewSA' href='/#/search?q=*&aois=2005&industries=&geos=&topics=&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest' name='btnViewSA' className='pure-button primary-action'>View Latest Content</a>
              </div>
            </div>
          </div>
        </>)
    } else {
      return (<div />)
    }
  }
}

function mapStateToProps (state) {
  document.title= "MLex | Browse latest content by Area of Interest"
  return {
    user: state.oidc.user
  }
}

export default connect(
  mapStateToProps
)(Home)
